/**
 * Environment utilities that can be used anywhere without circular dependencies
 */

import { Environment } from './types';

// Determine current environment
export const environment = (process.env.NEXT_PUBLIC_APP_ENV || process.env.NODE_ENV || 'development') as Environment;

/**
 * Environment checks
 */
export const isDevelopment = environment === 'development';
export const isProduction = environment === 'production';
export const isStaging = environment === 'staging';
export const isTest = environment === 'test';